export default __webpack_public_path__ + "static/media/is-defect.9efecbdb.png";